import React from 'react';
import { motion } from 'framer-motion';
import { FileText, CheckSquare, LayoutTemplate, Scissors, Calendar } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <FileText className="w-8 h-8 text-amber-500" data-id="element-154" />,
    text: "Guía PDF completa 'Cero Atracones Nocturnos (14 días)'"
  }, {
    icon: <CheckSquare className="w-8 h-8 text-amber-500" data-id="element-155" />,
    text: "Checklist imprimible 'NOCHE-CERRADA'"
  }, {
    icon: <LayoutTemplate className="w-8 h-8 text-amber-500" data-id="element-156" />,
    text: 'Plantillas: Mapa del Atracón + Tracker 14 días'
  }, {
    icon: <Scissors className="w-8 h-8 text-amber-500" data-id="element-157" />,
    text: "Tarjetas recortables 'Guión 90s'"
  }, {
    icon: <Calendar className="w-8 h-8 text-amber-500" data-id="element-158" />,
    text: 'Plan día por día (micro-acciones, 5–20 min)'
  }];
  return <section className="py-24 px-6 md:px-12 bg-[#111827] text-[#f5f5f0]" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-161">
          Lo que recibes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-162">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`
                bg-[#0a0e1a] p-6 rounded-xl border border-gray-800 flex items-start gap-4
                ${idx === items.length - 1 ? 'md:col-span-2' : ''}
              `} data-id="element-163">
              <div className="bg-amber-900/20 p-3 rounded-lg flex-shrink-0" data-id="element-164">
                {item.icon}
              </div>
              <p className="text-lg font-medium text-gray-200 pt-1" data-id="element-165">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        {/* Product mockup image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 rounded-2xl overflow-hidden border border-gray-800 shadow-2xl shadow-black/40" data-id="element-166">
          <img src="https://cdn.magicpatterns.com/uploads/uTe7akj5ZDDJQcoeFhpx83/foto2-salesletter-atracones.png" alt="Contenido del plan Cero Atracones Nocturnos" className="w-full h-auto object-cover" data-id="element-167" />
        </motion.div>
      </div>
    </section>;
}